import { createRouter, createWebHashHistory } from 'vue-router';
import store from '../store/index';
const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '主页'
    },
    component: () => import('@/views/home.vue'),
  },
  // 我的页面
  {
    path: '/mineworks',
    name: 'mineworks',
    meta: {
      title: '我的'
    },
    component: () => import('@/views/mine/home.vue'),
  },
  // 个人主页
  {
    path: '/personHome',
    name: 'personHome',
    meta: {
      title: '个人主页'
    },
    component: () => import('@/views/mine/personHome.vue'),
  },
  // 个人主页
  {
    path: '/otherHome',
    name: 'otherHome',
    meta: {
      title: '他人主页'
    },
    component: () => import('@/views/mine/otherHome.vue'),
  },
  // 关注/粉丝列表
  {
    path: '/followedList',
    name: 'followedList',
    meta: {
      title: '关注/粉丝列表'
    },
    component: () => import('@/views/mine/followedList.vue'),
  },
  //动画首页
  {
    path: '/animationHome',
    name: 'animationHome',
    meta: {
      title: '动画首页'
    },
    component: () => import('@/views/animation/home.vue'),
  },
  //动画对话
  {
    path: '/aniChat',
    name: 'aniChat',
    meta: {
      title: '动画对话'
    },
    component: () => import('@/views/animation/aniChat.vue'),
  },
  //动画详情页
  {
    path: '/aniDetail',
    name: 'aniDetail',
    meta: {
      title: '动画详情页'
    },
    component: () => import('@/views/animation/detail.vue'),
  },
  //写作大师
  {
    path: '/writeHome',
    name: 'writeHome',
    meta: {
      title: '写作首页'
    },
    component: () => import('@/views/write/home.vue'),
  },
  //写作大师对话
  {
    path: '/writeChat',
    name: 'writeChat',
    meta: {
      title: '写作首页'
    },
    component: () => import('@/views/write/writeChat.vue'),
  },
  // 写作大师详情页  
  {
    path: '/writeDetail',
    name: 'writeDetail',
    meta: {
      title: '写作详情页'
    },
    component: () => import('@/views/write/detail.vue'),
  },
  //ppt首页
  {
    path: '/pptHome',
    name: 'pptHome',
    meta: {
      title: 'PPT首页'
    },
    component: () => import('@/views/PPT/home.vue'),
  },
  {
    path: '/pptOutline',
    name: 'pptOutline',
    meta: {
      title: 'PPT大纲'
    },
    component: () => import('@/views/PPT/pptOutline.vue'),
  },
  // PPT详情页  
  {
    path: '/PPTDetail',
    name: 'PPTDetail',
    meta: {
      title: 'PPT详情页'
    },
    component: () => import('@/views/PPT/detail.vue'),
  },
  // 教学设计首页  
  {
    path: '/designHome',
    name: 'designHome',
    meta: {
      title: '教学设计首页'
    },
    component: () => import('@/views/design/home.vue'),
  },
  // 教学设计详情页  
  {
    path: '/designDetail',
    name: 'designDetail',
    meta: {
      title: '教学设计详情页'
    },
    component: () => import('@/views/design/detail.vue'),
  },
  //教学设计对话
  {
    path: '/designChat',
    name: 'designChat',
    meta: {
      title: '教学设计对话'
    },
    component: () => import('@/views/design/designChat.vue'),
  },
  //教学ppt
  {
    path: '/designPPT',
    name: 'designPPT',
    meta: {
      title: '教学设计PPT'
    },
    component: () => import('@/views/design/designPPT.vue'),
  },
  // 教学设计历史记录
   {
    path: '/designHistory',
    name: 'designHistory',
    meta: {
      title: '教学设计历史记录'
    },
    component: () => import('@/views/design/history.vue'),
  }, 
  {
    path: '/chatRoom',
    name: 'chatRoom',
    meta: {
      title: '聊天室'
    },
    component: () => import('@/views/chatRoom.vue'),
  },
  {
    path: '/historyRecord',
    name: 'historyRecord',
    meta: {
      title: '历史记录'
    },
    component: () => import('@/views/historyRecord.vue'),
  },
  {
    path: '/recharge',
    name: 'recharge',
    meta: {
      title: '账户'
    },
    component: () => import('@/views/recharge/index.vue'),
    redirect: '/recharge/index',
    children:[
      {
        path: '/recharge/index',
        name: 'rechargec',
        meta: {
          title: '购买'
        },
        component: () => import('@/views/recharge/recharge.vue'),
      },
      {
        path: '/recharge/history',
        name: 'rechargeh',
        meta: {
          title: '使用明细'
        },
        component: () => import('@/views/recharge/history.vue'),
      }
    ]
  
  },
  {
    path: '/pay',
    name: 'pay',
    meta: {
      title: '购买'
    },
    component: () => import('@/views/pay.vue'),
  },
  {
    path: '/createPPT',
    name: 'createPPT',
    meta: {
      title: '创建PPT'
    },
    component: () => import('@/views/createPPT.vue'),
  },
  {
    path: '/outlinePPT',
    name: 'outlinePPT',
    meta: {
      title: 'PPT大纲'
    },
    component: () => import('@/views/outlinePPT.vue'),
  },
  {
    path: '/pptIframe',
    name: 'pptIframe',
    meta: {
      title: 'pptIframe'
    },
    component: () => import('@/views/pptIframe.vue'),
  },
  {
    path: '/type4PPT',
    name: 'type4PPT',
    meta: {
      title: 'type4PPT'
    },
    component: () => import('@/views/type4PPT.vue'),
  },
  // 移动端嵌入
  {
    path: '/pptH5',
    name: 'pptH5',
    meta: {
      title: 'pptH5'
    },
    component: () => import('@/views/pptH5.vue'),
  },
  {
    path: '/pptH5t',
    name: 'pptH5t',
    meta: {
      title: 'pptH5t'
    },
    component: () => import('@/views/type4PPTH5.vue'),
  },
  // 智能作文
  {
    path: '/composition',
    name: 'composition',
    meta: {
      title: '智能作文',
      isComposition: true
    },
    component: () => import('@/views/composition/index.vue'),
    redirect: '/composition/index',
    children: [
      {
        path: '/composition/index',
        meta: {
          name: '首页'
        },
        component: () => import('@/views/composition/home.vue')
      },
      {
        path: '/composition/work',
        meta: {
          name: '作业'
        },
        component: () => import('@/views/composition/work/home.vue'),
        redirect: '/composition/work/index',
        children: [
          {
            path: '/composition/work/index',
            component: () => import('@/views/composition/work/index.vue'),
          },
          {
            path: '/composition/work/public',
            component: () => import('@/views/composition/work/public.vue'),
          },
          {
            path: '/composition/work/edit',
            component: () => import('@/views/composition/work/public.vue'),
          },
          {
            path: '/composition/work/task',
            component: () => import('@/views/composition/work/task.vue'),
          },
          {
            path: '/composition/work/submit',
            component: () => import('@/views/composition/work/submit.vue'),
          },
          {
            path: '/composition/work/review',
            meta: {
              isLeft: true,
              noHeader: true,
            },
            component: () => import('@/views/composition/work/review.vue'),
          },
          // 一期
          {
            path: '/composition/work/review1',
            meta: {
              isLeft: true,
              noHeader: true,
            },
            component: () => import('@/views/composition/work/review1.vue'),
          },
          {
            path: '/composition/work/classReport',
            meta: {
              isLeft: true,
              noHeader: true,
            },
            component: () => import('@/views/composition/work/classReport.vue'),
          },
          {
            path: '/composition/work/personalReport',
            meta: {
              isLeft: true,
              noHeader: true,
            },
            component: () => import('@/views/composition/work/personalReport.vue'),
          }
        ]
      },
      // 班级
      {
        path: '/composition/class',
        meta: {
          name: '班级'
        },
        component: () => import('@/views/composition/classManage/classRouter.vue'),
        redirect:'/composition/class/index',
        children: [
          {
            path: '/composition/class/index',
            component: () => import('@/views/composition/classManage/index.vue')
          },
          {
            path: '/composition/class/manage',
            component: () => import('@/views/composition/classManage/manage.vue')
          },
          {
            path: '/composition/class/task',
            component: () => import('@/views/composition/classManage/task.vue')
          }
        ]
      },
      // 学情
      {
        path: '/composition/studyDetail',
        meta: {
          name: '学情'
        },
        component: () => import('@/views/composition/studyDetail/studyRouter.vue'),
        redirect:'/composition/studyDetail/index',
        children: [
          {
            path: '/composition/studyDetail/index',
            component: () => import('@/views/composition/studyDetail/index.vue')
          },
          {
            path: '/composition/studyDetail/report',
            component: () => import('@/views/composition/studyDetail/report.vue'),
          },
         
        ]
      },
      // 批阅记录
      {
        path: '/composition/reviewRecord',
        meta: {
          name: '批阅记录'
        },
        component: () => import('@/views/composition/reviewRecord/recordRouter.vue'),
        redirect:'/composition/reviewRecord/index',
        children: [
          {
            path: '/composition/reviewRecord/index',
            component: () => import('@/views/composition/reviewRecord/index.vue')
          },
          {
            path: '/composition/reviewRecord/level2',
            component: () => import('@/views/composition/reviewRecord/level2.vue')
          },
          {
            path: '/composition/reviewRecord/speed',
            meta: {
                isLeft: true,
                noHeader: true,
            },
            component: () => import('@/views/composition/reviewRecord/speed.vue'),
          },

         
        ]
      },
    ]
  },

  {
    path: '/recharge1',
    name: 'recharge1',
    meta: {
      title: '账户',
      isComposition: true
    },
    component: () => import('@/views/recharge/index.vue'),
    redirect: '/recharge1/index',
    children:[
      {
        path: '/recharge1/index',
        name: 'rechargec1',
        meta: {
          title: '购买',
          noHeader: true,
        },
        component: () => import('@/views/recharge/recharge.vue'),
      },
      {
        path: '/recharge1/history',
        name: 'rechargeh1',
        meta: {
          title: '使用明细',
          noHeader: true,
        },
        component: () => import('@/views/recharge/history.vue'),
      }
    ]
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior (to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
})
// 路由守卫--start
router.beforeEach((to, from, next) => {
  if (to.path == '/home') {
    store.commit('changeChatType', null);
    store.commit('changeUuid', false);
  };
  next();
});

// 路由守卫--end
export default router
